import { Reducer, useReducer } from "react";
import { Actions, State } from "./types";

export const useScreenStatus = <R extends Reducer<State, Actions>>(
  reducer,
  initialState,
) => {
  const [state, dispatch] = useReducer<R>(reducer, initialState);
  return { state, dispatch };
};
